'use client';

import { GoogleTagManager } from '@next/third-parties/google';

import { useIsBot } from '@/app/hooks/useIsBot';
import { isEmbedInIframe, isSynthetics } from '@/app/utils/host';

interface GoogleTagManagerWrapperProps {
  gtmId: string;
}

export const GoogleTagManagerWrapper = ({
  gtmId,
}: GoogleTagManagerWrapperProps) => {
  const isBot = useIsBot();

  if (isSynthetics() || isEmbedInIframe() || isBot) {
    return null;
  }

  return <GoogleTagManager gtmId={gtmId} />;
};
